import React from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { getVendorInfo, vendorLogout } from './api/vendorApi';
// @ts-ignore
import neelsLogo from '../assets/logos/neels_logo.png';

const NAV = [
	{ to: '/vendor-portal/dashboard', label: 'Dashboard', icon: '🏠' },
	{ to: '/vendor-portal/requisitions', label: 'Requisitions', icon: '📋' },
	{ to: '/vendor-portal/quotations', label: 'My Quotations', icon: '📝' },
	{ to: '/vendor-portal/challans', label: 'Challans & Invoices', icon: '🧾' },
	{ to: '/vendor-portal/profile', label: 'Profile', icon: '👤' },
];

const titleFor = (path: string) => {
	const found = NAV.find((n) => path.startsWith(n.to));
	if (found) return found.label;
	if (path.includes('/requisitions/')) return 'Submit Quotation';
	if (path.includes('/quotations/')) return 'Quotation Detail';
	return 'Vendor Portal';
};

const VendorLayout = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const vendor = getVendorInfo();
	const initials = (vendor?.name || 'V')
		.split(' ')
		.map((w) => w[0])
		.slice(0, 2)
		.join('')
		.toUpperCase();

	const doLogout = () => {
		vendorLogout();
		navigate('/vendor-portal/login', { replace: true });
	};

	return (
		<div className='vp'>
			<div className='vp-shell'>
				<aside className='vp-sidebar'>
					<div className='vp-brand'>
						<img src={neelsLogo} alt='Neels' />
						<span className='vp-brand-badge'>Vendor</span>
					</div>
					<nav className='vp-nav'>
						{NAV.map((item) => (
							<NavLink
								key={item.to}
								to={item.to}
								className={({ isActive }) =>
									`vp-nav-link ${isActive ? 'active' : ''}`
								}>
								<span className='vp-icon'>{item.icon}</span>
								<span>{item.label}</span>
							</NavLink>
						))}
					</nav>
					<div className='vp-sidebar-foot'>
						<button
							type='button'
							className='vp-btn vp-btn-ghost vp-btn-block'
							onClick={doLogout}>
							⎋ Logout
						</button>
					</div>
				</aside>

				<main className='vp-main'>
					<header className='vp-topbar'>
						<h1>{titleFor(location.pathname)}</h1>
						<div className='vp-user'>
							<div style={{ textAlign: 'right' }}>
								<div style={{ fontWeight: 600 }}>{vendor?.name || 'Vendor'}</div>
								<div className='vp-muted' style={{ fontSize: 12 }}>
									{vendor?.email || ''}
								</div>
							</div>
							<div className='vp-avatar'>{initials}</div>
						</div>
					</header>
					<div className='vp-content'>
						<Outlet />
					</div>
				</main>
			</div>
		</div>
	);
};

export default VendorLayout;
